export const pluralize = (
  count: number,
  singular: string,
  plural: string = `${singular}s`
): string => {
  return count === 1 ? singular : plural;
};
